import { Component, OnInit, Inject, ViewChild,HostListener } from "@angular/core";
import { StandardService } from "../services/standard.service";
import { Standard } from "../models/standard";
import { Router, ActivatedRoute } from "@angular/router";
import {
  Constant,
  StandardTypeEnum,
  StandardListType,
  UserRoleUserOperation,
  UserRoleEnum,
} from "../core/constant";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DeleteDialogComponent } from "../delete-dialog/delete-dialog.component";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { FilteringGuide } from "../models/filteringGuide";
import { CryptographyService } from "../services/cryptography.service";
import { MatMenuTrigger } from "@angular/material/menu";
import { StandardList } from "../models/standard-list";
import { SelectedStandard } from "../models/selected-standard";
import { environment } from "../../environments/environment";
import { EquipmentStandard } from "../models/equipment-standard";
import { EquipmentStandardService } from "../services/equipment -standard.service";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { debug } from "util";
import { Sort } from "@angular/material/sort";
import { CustomEventNRService } from "../services/custom-event-nr.service";
import { AddendumService } from "../services/addendum.service";
import * as XLSX from "xlsx";


@Component({
  selector: "app-view-all-upcoming-standard-list",
  templateUrl: "./view-all-upcoming-standard-list.component.html",
  styleUrls: ["./view-all-upcoming-standard-list.component.scss"],
})
export class ViewAllUpcomingStandardListComponent implements OnInit {
  activePopupId: string | number | null = null;
  selectedRowsForExport: any[] = [];
  totalPages : any;
  searchKey: string = "";


  loading: boolean = false;
  exceptionOnCountries: number = 0;
  selected = "option2";
  grses: Standard[] = [];
  error: string = "";
  pageSizes: any[] = Constant.PageSizes;
  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;

  page: number = 1;
  pageSize: number = 10;
  collectionSize: number = 0;
  userRole: number;
  get standardTypeEnum() {
    return StandardTypeEnum;
  }
  filterList: FilteringGuide[] = [];

  isPageEnabled: boolean = true;
  canEditEquipmentStandard: boolean;
  canDeleteEquipmentStandard: boolean;
  constructor(
    private standardService: StandardService,
    private router: Router,
    private ngbModal: NgbModal,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,
    private activatedRoute: ActivatedRoute,
    private cryptographyService: CryptographyService,
    private equipmentStandardService: EquipmentStandardService,
    private customEventNRService: CustomEventNRService,
    public addendumService: AddendumService,
  ) {}

  ngOnInit() {
    this.filterList = this.standardService.upcomingStandardFiltration.filterSet;
    void 0;
    this.pageSize = this.standardService.upcomingStandardFiltration.pageSize;
    this.searchKey = this.standardService.upcomingStandardFiltration.searchKey;
    this.page =
      this.standardService.upcomingStandardFiltration.startingIndex || 1;

    this.userRole = this.getEffectiveUserRole();
    this.setUserPrivilages();
    this.getStandards();
  }

  getEffectiveUserRole(): number {
    if (sessionStorage.getItem("userRoleId")) {
      return this.cryptographyService.decryptData(
        sessionStorage.getItem("userRoleId"),
      );
    }
    return this.cryptographyService.decryptData(this.storage.get("userRole"));
  }

  isGlobalAdmin(): boolean {
    return this.getEffectiveUserRole() === UserRoleEnum.GlobalAdmin;
  }

  selectedItemsPerPageChange(event) {
    this.page = 1;
    this.pageSize = event.value;
    this.getStandards();
  }

  getStandards(): void {
    this.filterList = this.standardService.upcomingStandardFiltration.filterSet;
    void 0;
    this.loading = true;
    this.standardService.upcomingStandardFiltration.pageSize = this.pageSize;
    this.standardService.upcomingStandardFiltration.startingIndex = this.page;
    this.standardService
      .getAllStandards(
        (this.page - 1) * this.pageSize,
        this.pageSize,
        StandardListType.Upcoming,
        this.filterList,
        null,
        this.searchKey,
      )

      .subscribe((data: StandardList) => {
        void 0;
        // this.exceptionOnCountries = data.standardDetailList.map((o)=> ) ?
        this.grses = data.standardDetailList.map((o) => o);
      
        void 0;

        this.collectionSize = data.count;
          if(this.filterList.length > 0){
          this.customEventNRService.sendFilterEvent("Grsallfilters", JSON.stringify(this.filterList), this.grses.length);
        }
        this.totalPages = Math.ceil(this.collectionSize / this.pageSize);

        this.loading = false;
        (error: string) => {
          this.error = error;
          this.loading = false;
        };
      });
  }

  compare(
    a: number | string | Date,
    b: number | string | Date,
    isAsc: boolean
  ) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortData(sort: Sort) {
    if (!sort.active || sort.direction === "" || !(this.grses.length > 0)) {
      return;
    }

    const isAsc = sort.direction === "asc";
    this.grses.sort((a, b) => {
      switch (sort.active) {
        case "title":
          return this.compare(a.title, b.title, isAsc);
        case "category":
          return this.compare(a.category.name, b.category.name, isAsc);
        case "desc":
          return this.compare(a.shortDescription, b.shortDescription, isAsc);
      }
    });
  }

  setUserPrivilages() {
    if (!environment.skipAuthentication) {
      let userRoleUserOperation = this.storage.get("userRoleUserOperation")
        ? this.cryptographyService.decryptData(
            this.storage.get("userRoleUserOperation")
          )
        : this.storage.get("userRoleUserOperation");
      if (userRoleUserOperation) {
        this.canEditEquipmentStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanEditEquipmentStandard
          ) !== -1;
        this.canDeleteEquipmentStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanDeleteEquipmentStandard
          ) !== -1;
      }
    }
  }
  rowSelected(item: Standard): void {
    if (item.standardType.id == StandardTypeEnum.GlobalEquipmentStandard) {
      this.router.navigate([
        "/view-upcoming-equipments-standard-detail/" + item.id,
      ]);
    } else {
      this.router.navigate(["/view-upcoming-standard-detail/" + item.id]);
    }
  }

  openDeleteModal(item, event) {
    event.stopPropagation();
    this.activePopupId = null;
    const modalRef = this.ngbModal.open(DeleteDialogComponent);
    modalRef.componentInstance.title =
      "Do you want to remove this standard from the list? ";
    modalRef.componentInstance.deleteItem = item;
    if (
      item.standardTypeId == StandardTypeEnum.GlobalMinimumRestaurantStandard ||
      item.standardTypeId == StandardTypeEnum.GlobalEquipmentStandard ||
      StandardTypeEnum.OperationsStandards
    ) {
      modalRef.componentInstance.message =
        "All the dependencies will be removed along with this standard";
    }
    modalRef.componentInstance.deletePopupEmit.subscribe((deleteItem) => {
      if (deleteItem != null) {
        if (item.standardTypeId == StandardTypeEnum.GlobalEquipmentStandard) {
          let equipmentStandard = new EquipmentStandard();
          equipmentStandard.id = deleteItem.equipmentStandard.id;
          equipmentStandard.isDeleted = true;
          this.loading = true;
          this.equipmentStandardService
            .updateEquipmentStandard(equipmentStandard)
            .subscribe((data: any) => {
              this.loading = false;
              this.page = 1;
              this.getStandards();
            });
        } else {
          let grs = new SelectedStandard();
          grs.standard.id = deleteItem.id;
          grs.standard.isDeleted = true;
          this.loading = true;
          this.standardService
            .removeGrbes(grs.standard)
            .subscribe((data: any) => {
              this.loading = false;
              this.page = 1;
              this.getStandards();
            });
        }
      }
      this.ngbModal.dismissAll();
    });
    this.trigger?.closeMenu();
  }

  actionMenuOpen(event) {
    event.stopPropagation();
  }

  receivedFilteration($event) {
    this.isPageEnabled = false;
    this.filterList = $event;
    this.standardService.upcomingStandardFiltration.filterSet = this.filterList;
    this.pageSize = 10;
    this.page = 1;
    this.getStandards();
  }

  closeMatMenuAndOpenDeleteModal(item, event) {
    this.trigger.closeMenu();
    setTimeout(() => {
      this.openDeleteModal(item, event);
    }, 100);
  }

 

  downloadExcel() {
    if (this.selectedRowsForExport.length > 0) {
      this.exportSelected();
      return;
    }

    this.standardService
      .downloadExcel(
        0,
        this.collectionSize,
        StandardListType.Upcoming,
        this.filterList,
        null,
        null
      )
      .subscribe(
        (response: any) => {
          let filename =
            "Upcoming_Standard_List " + new Date().toLocaleString();
          this.standardService.saveExportBlob(response, filename);
        },
        (error: any) => {
          const modalRef = this.ngbModal.open(FailModuleComponent);
          modalRef.componentInstance.errorMessage = error.error
            ? error.error.Message
            : error.message;
        }
      );
  }

  exportSelected(): void {
    const selectedData = (this.grses || []).filter((item) =>
      this.selectedRowsForExport.includes(item.id),
    );
    if (selectedData.length === 0) {
      const modalRef = this.ngbModal.open(FailModuleComponent);
      modalRef.componentInstance.errorMessage =
        "No selected standards to export.";
      return;
    }
    const formattedData = selectedData.map((item) => ({
      "Standard ID": item.id,
      Title: item.title,
      Type: item.standardType?.name || "",
      Location: this.getLocationNames(item),
      Category: item.category?.name ?? "",
      "Effective From": item.newRestaurantsEffectiveFrom
        ? new Date(item.newRestaurantsEffectiveFrom).toLocaleDateString("en-US")
        : "N/A",
    }));

    this.writeExcelFile(
      formattedData,
      "Selected_Upcoming_Standards_List " + new Date().toLocaleString() + ".xlsx",
    );
  }

  writeExcelFile(data: any[], fileName: string): void {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Upcoming Standards");
    this.standardService.saveXlsxWorkbook(workbook, fileName);
  }

  getLocationNames(item): any {
    if (item.standardLocation && item.standardLocation.length > 0) {
      return item.standardLocation
        .map((loc) => loc.locationType.name)
        .join(", ");
    } else {
      return item.locationType.name;
    }
  }

  addAddendum(standardId: number, event): void {
    this.addendumService.isCommingFromNrbes = false;
    this.addendumService.isCommingFromAllStandards = false;
    this.addendumService.isCommingFromNationalEquipmentList = false;
    event?.stopPropagation?.();
    this.router.navigate(["/add-addendum-upcoming/" + standardId]);
  }

   extractDescription(description: string): string {
    const extracted = description.slice(0, 80);
    return extracted.length < description.length
      ? extracted + "..."
      : extracted;
  }
  togglePopup(event: MouseEvent, item: any): void {
    event.stopPropagation();
    // Close if clicking the same row, otherwise open new one
    this.activePopupId = this.activePopupId === item.id ? null : item.id;
  }

  onEdit(item) {
    this.activePopupId = null;
    this.standardService.standardEditPreviousRoute =
      this.activatedRoute.snapshot.routeConfig.path;
    if (item.standardType.id != this.standardTypeEnum.GlobalEquipmentStandard) {
      this.router.navigate(["/add-grs", item.id]);
    } else {
      this.router.navigate(["/edit-eq-standards-global", item.id]);
    }
  }
 
    getStandardIcon(id:number){
     if (id === 4) {
    return '/assets/images/building-standrad.svg';
  }else if(id == 8){
    return '/assets/images/operation-standard.svg'
  }else{

    return '/assets/images/global approved icon.svg';
  }
  
}

onCheckboxChange(event: any, id: number) {
    if (event.checked) {
      if (!this.selectedRowsForExport.includes(id)) {
        this.selectedRowsForExport.push(id);
        console.log("Added:", id);
      }
    } else {
      const index = this.selectedRowsForExport.indexOf(id);
      if (index > -1) {
        this.selectedRowsForExport.splice(index, 1);
      }
    }
  }
   isSelected(id: number): boolean {
    return this.selectedRowsForExport.includes(id);
  }

  getSelectableRowsOnPage(): Standard[] {
    return this.grses || [];
  }

  isAllOnPageSelected(): boolean {
    const selectable = this.getSelectableRowsOnPage();
    if (selectable.length === 0) {
      return false;
    }
    return selectable.every((item) => this.isSelected(item.id));
  }

  isSomeOnPageSelected(): boolean {
    const selectable = this.getSelectableRowsOnPage();
    if (selectable.length === 0) {
      return false;
    }
    const selectedCount = selectable.filter((item) =>
      this.isSelected(item.id),
    ).length;
    return selectedCount > 0 && selectedCount < selectable.length;
  }

  selectAllOnPageChange(event: any): void {
    const selectable = this.getSelectableRowsOnPage();
    if (event.checked) {
      selectable.forEach((item) => {
        if (!this.selectedRowsForExport.includes(item.id)) {
          this.selectedRowsForExport.push(item.id);
        }
      });
    } else {
      selectable.forEach((item) => {
        const index = this.selectedRowsForExport.indexOf(item.id);
        if (index > -1) {
          this.selectedRowsForExport.splice(index, 1);
        }
      });
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    

    if (!target.closest('.grid-actions')) {
      this.activePopupId = null;
    }
    
   
  }

   goToNextPage() {
    if (this.page < this.totalPages) {
      this.page++;
      this.getStandards();
    }
  }

  goToPreviousPage() {
    if (this.page > 1) {
      this.page--;
      this.getStandards();
    }
  }

  addSearchKey(searchKey:string) {
    event?.preventDefault();
    this.searchKey = searchKey;
    this.page = 1;
    this.standardService.upcomingStandardFiltration.searchKey = this.searchKey;
    this.getStandards();
  }
  onSearchFromChild(searchValue: string) {
    // this.searchKey = searchValue;
    this.addSearchKey(searchValue);
  }

  onExportFiltersApplied(exportFilterList: FilteringGuide[]) {
    // alert("Export filters applied: " + JSON.stringify(exportFilterList));
    this.filterList = exportFilterList;
    this.downloadExcel();
  }
}
